<template>
    <div>
        <Breadcumb title="Bonnes Pratiques" :breadcumb-data="breadcumbData">
            <b-btn v-bind:to="'add/'" variant="primary"><i class="ion ion-md-add"></i>&nbsp; Nouveau sujet</b-btn>
        </Breadcumb>
        <b-card no-body class="mb-3 cardcontainer">
            <div>
                <b-card-body class="py-3">
                    
                    <div class="row no-gutters align-items-center">
                        <div class="col">
                            <b-btn v-bind:to="'/share/guidelines/detail/'"  class="text-big font-weight-semibold" variant="primary">
                                Bonnes pratiques : Article 1
                            </b-btn>
                            <div class="text-muted small mt-1">
                                Crée le 11/02/2021&nbsp; par
                                Alexandre Dupont
                            </div>
                        </div>
                    </div>
                
                </b-card-body>
            </div>
        </b-card>
    </div>
</template>

<script>
    import Breadcumb from '../components/breadcumb'
    import { mapState } from 'vuex';

    export default {
        name: 'pages-forums-threads',
        components: { Breadcumb},
        computed: mapState({ category: state => state.exchange.category}),
        mounted() {
                    this.breadcumbData =  [
                        {text: this.$t('welcome'), href: '/dashboard/'},
                        {text: "Guide des bonnes pratiques", active:true}
                    ]
        },
        data() {
            return {
                breadcumbData: []
            }
        }
    }
</script>
